export default __webpack_public_path__ + "static/media/calendar.ad8f6bdf.svg";